import styled from 'styled-components';
import { StyledParagraph as Paragraph } from '../Typography/typography.styles';

export const StyledNav = styled.nav`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin: 0 65px;
`;

export const StyledParagraph = styled(Paragraph)`
  font-weight: bold;
  margin-top: 0;

  & + & {
    margin-top: 0;
  }
`;

export const StyledMobileMenu = styled.nav<{ $open: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.palette.primary.bold};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: 32px;
  position: absolute;
  text-align: center;
  top: 0;
  transform: ${({ $open }) => ($open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  width: 100vw;
  z-index: 9;

  a {
    font-size: ${({ theme }) => theme.utils.pxToRem(28)};
    line-height: 150%;

    &.active,
    &:hover {
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;
